module.exports = __webpack_public_path__ + "img/impactoF4.ca318979.png";